import React, { FC, useCallback, useState } from 'react';

import type { ImagePreloaderProps } from './types';

import { Icon, IconName } from '../Icon';
import { getSrcAttributes } from './utils/get-src-attributes';

export const ImagePreloader: FC<ImagePreloaderProps> = ({
  imageSrc,
  defaultImage = '',
  height,
  width,
  alt,
  className,
}) => {
  const [fallbackSrc, setFallbackSrc] = useState<string>();

  const imgProps = { width, height, alt, className };

  const onErrorHandler = useCallback(() => {
    setFallbackSrc(defaultImage);
  }, [defaultImage]);

  if (fallbackSrc) {
    return (
      <Icon icon={`sport-${fallbackSrc}` as IconName}
            className={className}
            size={width} />
    );
  }

  return (
    <img {...imgProps}
         {...getSrcAttributes(imageSrc)}
         onError={onErrorHandler}
         alt={alt ?? ''} />
  );
};
